import styled from 'styled-components';
import { getTypographyStyles } from '../../utils/index.js';
import { typographyTokenMapping } from '../../utils/get-typography-styles/tokens/index.js';
export const StyledHeadline = styled.div `
  margin: 0;
  color: ${(props) => props.theme.global.color.typography.headline.default};

  ${(props) => {
    const { type, order, weight } = props.variant;
    const getTokenType = () => {
        if (type === 'headline') {
            return typographyTokenMapping.sys.typography[type]['order'][order][weight];
        }
        return typographyTokenMapping.sys.typography[type]['order'][order][weight];
    };
    return getTypographyStyles(getTokenType());
}};
`;
//# sourceMappingURL=index.styles.js.map